import type { AuthenticatedShellSection } from "../../../components/authenticated/AuthenticatedAppShell";

export function formatSectionTitle(section: AuthenticatedShellSection): string {
  if (section === "today") {
    return "Início";
  }

  if (section === "customers") {
    return "Clientes";
  }

  if (section === "conversations") {
    return "Conversas";
  }

  if (section === "services") {
    return "Serviços";
  }

  if (section === "team") {
    return "Equipe";
  }

  if (section === "finance" || section === "subscription") {
    return "Financeiro";
  }

  if (section === "insights") {
    return "Insights";
  }

  if (section === "settings") {
    return "Ajustes";
  }

  return "Agenda";
}

export function formatUserFirstName(email: string) {
  const raw = email.split("@")[0]?.split(/[._-]/)[0] || "Joao";
  return raw.charAt(0).toUpperCase() + raw.slice(1);
}
